module.exports = __webpack_public_path__ + "static/bone_devil-79dedcfae58ebd049d6df6fa893b90c3.jpg";